import { ReactElement } from 'react';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { SxProps, Theme } from '@mui/material/styles';
import { styled, useThemeProps } from '@mui/material/styles';

import SportsGolfIcon from '@mui/icons-material/GolfCourse';

import { keyframes } from '@mui/system';

const spinY = keyframes`
  from {
    transform: rotateY(0deg);
  }
  to {
    transform: rotateY(360deg);
  }
`;

export type HourglassVariant = 'page' | 'inline';

export interface HourglassProps {
  variant?: HourglassVariant;
  sx?: SxProps<Theme>;
}

interface HourglassOwnerState {
  variant: HourglassVariant;
}

const HourglassRoot = styled('div', {
  name: 'GratiHourglass',
  slot: 'root',
  overridesResolver: (_props, styles) => {
    return styles.root;
  },
})<{ ownerState: HourglassOwnerState }>(() => ({}));

export default function Hourglass(inProps: HourglassProps): ReactElement {
  const props = useThemeProps({ props: inProps, name: 'GratiHourglass' });
  const { variant = 'page', sx } = props;

  const ownerState: HourglassOwnerState = { variant };

  return (
    <HourglassRoot ownerState={ownerState} sx={sx}>
      <Box
        role="status"
        aria-live="polite"
        aria-label="Loading"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative"
        }}>
        <CircularProgress
          className="GratiHourglass-progress"
          sx={{
            color: 'primary.main',
            position: 'absolute',
            zIndex: 1,
          }}
        />
        <Box
          sx={{
            perspective: '1000px',
            transformStyle: 'preserve-3d',
          }}
        >
          <SportsGolfIcon
            aria-hidden="true"
            className="GratiHourglass-icon"
            sx={{
              animation: `${spinY} 1.5s linear infinite`,
              color: 'primary.main',
            }}
          />
        </Box>
      </Box>
    </HourglassRoot>
  );
}
